var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "addextracharges"
  }, [(_vm.createextracharges == false) ? _c('b-card', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true",
      "title": "Search Filter"
    }
  }), _vm._v(" "), _c('label'), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Add Extra Charges"
    },
    on: {
      "click": _vm.goToAddCharges
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-2x",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "style": "color: red;"
    }
  })])])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("AWB Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-id-card-o' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbnumber),
      expression: "awbnumber"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "awbnumber",
      "id": "awbnumber",
      "placeholder": "Enter AWB Number"
    },
    domProps: {
      "value": (_vm.awbnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbnumber = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Allocation Type")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gear' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.allocationTypeList,
      "placeholder": "Select Allocation Type",
      "append-to-body": true,
      "name": "allocationtype"
    },
    model: {
      value: (_vm.allocationtypesearch),
      callback: function($$v) {
        _vm.allocationtypesearch = $$v
      },
      expression: "allocationtypesearch"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Date Range ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "range": "",
      "shortcuts": _vm.shortcuts,
      "lang": "en",
      "name": "daterange",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.daterange),
      callback: function($$v) {
        _vm.daterange = $$v
      },
      expression: "daterange"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "7rem"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getExtraChargeList
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n                                    "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" AWB Extra Charges Listing")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.totalCount))])]), _vm._v(" "), _c('div', {
    staticClass: "clientnote ",
    staticStyle: {
      "margin-bottom": "5px",
      "margin-left": "6rem"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.downloadXls
    }
  }, [_vm._v("Export Data")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note:Only 30 days data will be visible in excel")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto",
      "width": "100%"
    }
  }, [_c('custom-expandable-table', {
    key: _vm.expandableKey,
    attrs: {
      "columns": _vm.tableColumn,
      "isEditHidden": false,
      "items": _vm.tableItems,
      "innerTableHeader": _vm.innerTableColumn,
      "offset": _vm.offset
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  }, [_c('b-card', [_c('h6', [_vm._v("AWB Extra Charges Details")]), _vm._v(" "), _c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "details"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Extra Charges Category")]), _vm._v(" "), _c('th', [_vm._v("Charges(INR)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Uploded Documents")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("Odd Size Shipments Charges (>100 Kg/MPS):")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.shipmentsizedcharge))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.shipmentsizedchargedocument == 'png' || _vm.shipmentsizedchargedocument == 'jpg' || _vm.shipmentsizedchargedocument == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Open Image"
    },
    on: {
      "click": function($event) {
        _vm.openImage(_vm.shipmentsizedchargedoc)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.shipmentsizedchargedoc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.shipmentsizedchargedoc
    }
  }, [_c('span', {
    staticClass: "close",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.shipmentsizedchargedoc)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.shipmentsizedchargedoc,
      "src": _vm.shipmentsizedchargedoc
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })]), _vm._v(" "), (_vm.shipmentsizedchargedocument == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.shipmentsizedchargedoc)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shipmentsizedchargedocument == 'doc' || _vm.shipmentsizedchargedocument == 'docx') ? _c('i', {
    staticClass: "fa fa-file-word-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.shipmentsizedchargedoc)
      }
    }
  }) : _vm._e(), _vm._v("  \n                                "), (_vm.shipmentsizedchargedocument == '') ? _c('i', {
    staticClass: "text-danger",
    attrs: {
      "title": "No Image",
      "aria-hidden": "true"
    }
  }, [_vm._v("No File Uploaded")]) : _vm._e(), _vm._v("  \n                              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("Mathadi/Varai/Union Charges:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.mathadicharge))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.mathadidocument == 'png' || _vm.mathadidocument == 'jpg' || _vm.mathadidocument == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Open Image"
    },
    on: {
      "click": function($event) {
        _vm.openImage(_vm.mathadichargedoc)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.mathadichargedoc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.mathadichargedoc
    }
  }, [_c('span', {
    staticClass: "close",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.mathadichargedoc)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.mathadichargedoc,
      "src": _vm.mathadichargedoc
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })]), _vm._v(" "), (_vm.mathadidocument == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.mathadichargedoc)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mathadidocument == 'doc' || _vm.mathadidocument == 'docx') ? _c('i', {
    staticClass: "fa fa-file-word-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.mathadichargedoc)
      }
    }
  }) : _vm._e(), _vm._v("  \n                                "), (_vm.mathadidocument == '') ? _c('i', {
    staticClass: "text-danger",
    attrs: {
      "title": "No Image",
      "aria-hidden": "true"
    }
  }, [_vm._v("No File Uploaded")]) : _vm._e(), _vm._v("  \n                              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("Open Pick-up / Delivery Charges:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.portgagecharge))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.portgagesdocument == 'png' || _vm.portgagesdocument == 'jpg' || _vm.portgagesdocument == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Open Image"
    },
    on: {
      "click": function($event) {
        _vm.openImage(_vm.portgagechargedoc)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.portgagesdocument
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.portgagesdocument
    }
  }, [_c('span', {
    staticClass: "close",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.portgagechargedoc)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.portgagechargedoc,
      "src": _vm.portgagechargedoc
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })]), _vm._v(" "), (_vm.portgagesdocument == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.portgagechargedoc)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.portgagesdocument == 'doc' || _vm.portgagesdocument == 'docx') ? _c('i', {
    staticClass: "fa fa-file-word-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.portgagechargedoc)
      }
    }
  }) : _vm._e(), _vm._v("  \n                                "), (_vm.portgagesdocument == '') ? _c('i', {
    staticClass: "text-danger",
    attrs: {
      "title": "No Image",
      "aria-hidden": "true"
    }
  }, [_vm._v("No File Uploaded")]) : _vm._e(), _vm._v("  \n                              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("Appointment/CSD/Mall Delivery Charges:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.specialdeliverycharge))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.specialdeliverydocument == 'png' || _vm.specialdeliverydocument == 'jpg' || _vm.specialdeliverydocument == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Open Image"
    },
    on: {
      "click": function($event) {
        _vm.openImage(_vm.specialdeliverychargedoc)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.specialdeliverychargedoc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.specialdeliverychargedoc
    }
  }, [_c('span', {
    staticClass: "close",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.specialdeliverychargedoc)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.specialdeliverychargedoc,
      "src": _vm.specialdeliverychargedoc
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })]), _vm._v(" "), (_vm.specialdeliverydocument == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.specialdeliverychargedoc)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.specialdeliverydocument == 'doc' || _vm.specialdeliverydocument == 'docx') ? _c('i', {
    staticClass: "fa fa-file-word-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.specialdeliverychargedoc)
      }
    }
  }) : _vm._e(), _vm._v("  \n                                "), (_vm.specialdeliverydocument == '') ? _c('i', {
    staticClass: "text-danger",
    attrs: {
      "title": "No Image",
      "aria-hidden": "true"
    }
  }, [_vm._v("No File Uploaded")]) : _vm._e(), _vm._v("  \n                              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("Floor Pick-up / Delivery:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.loadingcharge))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.loadingunloadingdocument == 'png' || _vm.loadingunloadingdocument == 'jpg' || _vm.loadingunloadingdocument == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Open Image"
    },
    on: {
      "click": function($event) {
        _vm.openImage(_vm.loadingchargedoc)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.loadingchargedoc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.loadingchargedoc
    }
  }, [_c('span', {
    staticClass: "close",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.loadingchargedoc)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.loadingchargedoc,
      "src": _vm.loadingchargedoc
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })]), _vm._v(" "), (_vm.loadingunloadingdocument == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.loadingchargedoc)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loadingunloadingdocument == 'doc' || _vm.loadingunloadingdocument == 'docx') ? _c('i', {
    staticClass: "fa fa-file-word-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.loadingchargedoc)
      }
    }
  }) : _vm._e(), _vm._v("  \n                                "), (_vm.loadingunloadingdocument == '') ? _c('i', {
    staticClass: "text-danger",
    attrs: {
      "title": "No Image",
      "aria-hidden": "true"
    }
  }, [_vm._v("No File Uploaded")]) : _vm._e(), _vm._v("  \n                              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("ODA Charges:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.odacharge))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.odadocument == 'png' || _vm.odadocument == 'jpg' || _vm.odadocument == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Open Image"
    },
    on: {
      "click": function($event) {
        _vm.openImage(_vm.odachargedoc)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.odachargedoc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.odachargedoc
    }
  }, [_c('span', {
    staticClass: "close",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.odachargedoc)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.odachargedoc,
      "src": _vm.odachargedoc
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })]), _vm._v(" "), (_vm.odadocument == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.odachargedoc)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.odadocument == 'doc' || _vm.odadocument == 'docx') ? _c('i', {
    staticClass: "fa fa-file-word-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.odachargedoc)
      }
    }
  }) : _vm._e(), _vm._v("  \n                                "), (_vm.odadocument == '') ? _c('i', {
    staticClass: "text-danger",
    attrs: {
      "title": "No Image",
      "aria-hidden": "true"
    }
  }, [_vm._v("No File Uploaded")]) : _vm._e(), _vm._v("  \n                              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("Other Charges:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.fulltruckcharge))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.fulltruckloaddocument == 'png' || _vm.fulltruckloaddocument == 'jpg' || _vm.fulltruckloaddocument == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Open Image"
    },
    on: {
      "click": function($event) {
        _vm.openImage(_vm.fulltruckchargedoc)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.fulltruckchargedoc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.fulltruckchargedoc
    }
  }, [_c('span', {
    staticClass: "close",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.fulltruckchargedoc)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.fulltruckchargedoc,
      "src": _vm.fulltruckchargedoc
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })]), _vm._v(" "), (_vm.fulltruckloaddocument == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.fulltruckchargedoc)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fulltruckloaddocument == 'doc' || _vm.fulltruckloaddocument == 'docx') ? _c('i', {
    staticClass: "fa fa-file-word-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.fulltruckchargedoc)
      }
    }
  }) : _vm._e(), _vm._v("  \n                                "), (_vm.fulltruckloaddocument == '') ? _c('i', {
    staticClass: "text-danger",
    attrs: {
      "title": "No Image",
      "aria-hidden": "true"
    }
  }, [_vm._v("No File Uploaded")]) : _vm._e(), _vm._v("  \n                              ")])])])])])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), _c('div', [(_vm.createextracharges == true) ? _c('div', [_c('create-extra-charges', {
    attrs: {
      "childcharges": _vm.parentcharges
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.showprint) ? _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('AddExtraChargesPDF', {
    attrs: {
      "payload": _vm.pdfpayload
    }
  })], 1) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ff8825c","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/TripManagement/AddExtraCharges/AddExtraCharges.component.html
// module id = 1416
// module chunks = 3